import React, { ReactNode } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Banner, { BANNER_COLOR_DANGER, BannerType } from '@divvy-web/skylab.banner'
import CollapsibleList from '@divvy-web/skylab.collapsiblelist'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import Divider from '@sputnik/components/Divider'

import styles from './styles.module.scss'

export interface SectionCollapsibleListProps {
  headerText: ReactNode
  onEditClick?: () => void
  hasMissingInfo: boolean
}

const SectionCollapsibleList = ({
  headerText,
  onEditClick,
  hasMissingInfo,
  children,
}: React.PropsWithChildren<SectionCollapsibleListProps>) => {
  const [getClassName, makeTestId] = useNameFormatter('SectionCollapsibleList')

  return (
    <div className={styles[getClassName('')]}>
      <CollapsibleList
        isHeaderActive
        menuIsOpen
        header={
          <>
            <h3 className={styles[getClassName('header')]}>{headerText}</h3>
            {onEditClick && (
              <TextLink
                className={styles[getClassName('editLink')]}
                size={TextLinkSizes.REGULAR}
                onClick={onEditClick}
              >
                <FormattedMessage
                  defaultMessage='Edit'
                  id='sputnik.SectionCollapsibleList__wEQDC6'
                />
              </TextLink>
            )}
          </>
        }
      >
        {hasMissingInfo && (
          <Banner
            backgroundColor={BANNER_COLOR_DANGER}
            bannerType={BannerType.Error}
            dataTestId={makeTestId('missing-info')}
            messageContent={
              <FormattedMessage
                defaultMessage='Complete all fields marked with an asterisk to proceed.'
                id='sputnik.SectionCollapsibleList__61gZJm'
              />
            }
            titleText={
              <FormattedMessage
                defaultMessage='Required info missing'
                id='sputnik.SectionCollapsibleList__+UZ4VC'
              />
            }
          />
        )}
        {children}
      </CollapsibleList>
      <Divider />
    </div>
  )
}

export default SectionCollapsibleList
